export const defaultBrandColors = {
  tertiary: {
    main: '#f000ff',
  },
  quaternary: {
    main: '#4deeea',
  },
};
